const Layout = () => import("@/layout/index.vue");

export default {
  path: "/options",
  name: "options",
  component: Layout,
  meta: {
    title: "操作页面",
    showLink: false
  },
  children: [
    {
      path: "/enterprise/options/index",
      name: "EnterpriseOptions",
      component: () => import("@/views/account/enterprise/options/index.vue"),
      meta: {
        title: "企业管理操作"
      }
    }
  ]
} satisfies RouteConfigsTable;
